import request from '@/utils/httpRequest'

// 首页-其他信息
export function ApiWebIndex () {
  return request({
    url: request.adornUrl('/web/index/info'),
    method: 'get',
    params: request.adornParams()
  })
}

// 导航栏--web展示页获取信息
export function ApiWebMenu () {
  return request({
    url: request.adornUrl('/web/nav/menu'),
    method: 'get',
    params: request.adornParams()
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js